import React, { createContext, useContext, useState, ReactNode } from "react";
import { LanguageCode } from "../types/post";

interface LanguageContextType {
  currentLanguage: LanguageCode;
  setLanguage: (language: LanguageCode) => void;
  availableLanguages: { code: LanguageCode; name: string; flag: string }[];
}

const LanguageContext = createContext<LanguageContextType | undefined>(
  undefined
);

interface LanguageProviderProps {
  children: ReactNode;
}

export const LanguageProvider: React.FC<LanguageProviderProps> = ({
  children,
}) => {
  // Fixed to Polish for support portal
  const [currentLanguage] = useState<LanguageCode>("pl");

  const availableLanguages = [
    { code: "pl" as LanguageCode, name: "Polski", flag: "🇵🇱" },
    { code: "en" as LanguageCode, name: "English", flag: "🇺🇸" },
    { code: "uk" as LanguageCode, name: "Українська", flag: "🇺🇦" },
  ];

  // No language switching needed for support portal
  const setLanguage = () => {
    // Language is fixed to Polish
  };

  return (
    <LanguageContext.Provider
      value={{
        currentLanguage,
        setLanguage,
        availableLanguages,
      }}
    >
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (context === undefined) {
    throw new Error("useLanguage must be used within a LanguageProvider");
  }
  return context;
};
